import { useState } from "react";

import AiKnowledgeModal from "./ai-knowledge-modal";
import AiKnowledgePreview from "./ai-knowledge-preview";

const AiKnowledgeEditor = ({
  value,
  onSave,
  label,
  description,
  placeholder,
}: {
  value: string | null;
  onSave: (jsonValue: string) => Promise<void>;
  label: string;
  description: string;
  placeholder: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <AiKnowledgePreview
        value={value}
        label={label}
        placeholder={placeholder}
        onOpen={() => setIsOpen(true)}
      />
      {isOpen && (
        <AiKnowledgeModal
          value={value}
          label={label}
          description={description}
          placeholder={placeholder}
          onSave={onSave}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  );
};

export default AiKnowledgeEditor;
